import React, {FC, useEffect, useState} from 'react'
import {Link, useLocation, useNavigate} from 'react-router-dom'
import {PageTitle} from '../../../_metronic/layout/core'
import Select from 'react-select'
import {
  fetchData,
  getTranslatedValue,
  hasSpecialCharacters,
  isSpecificSpecialCharacters,
  toasterrormsg,
  toastsuccessmsg,
} from '../../../reusable'
import {ToastContainer} from 'react-toastify'
import {AddHotelHeader} from './AddHotelHeader'
import PhoneInput from 'react-phone-input-2'
import {Tr} from '../../../_metronic/i18n/Tr'
import {KTIcon} from '../../../_metronic/helpers'
import Swal from 'sweetalert2'
import {useLang} from '../../../_metronic/i18n/Metronici18n'

const AddHotelBasicInfo: FC = () => {
  const t = Tr();
  const lang = useLang();
  const navigate = useNavigate();
  const categoryId = sessionStorage.getItem('categoryId');
  useEffect(() => {
    if (categoryId != '1') {
      navigate('../dashboard/')
    }
  }, [categoryId]);
  const location = useLocation();
  const editHotelId = (location.state as any)?.hotelId || '';
  const [hotelDetails, setHotelDetails] = useState([]);

  var vendorId = ''
  const vendorData = sessionStorage.getItem('vendor')
  if (vendorData) {
    var vendor = JSON.parse(vendorData)
    vendorId = vendor.vendorId
  } else {
    console.log('No vendor data found')
  }
  const [loading, setLoading] = useState(false)
  const [disable, setDisable] = useState(false)
  const [hotelNameEN, setHotelNameEN] = useState('')
  const [hotelNameRU, setHotelNameRU] = useState('')
  const [hotelNameUZ, setHotelNameUZ] = useState('')
  const [contactPersonName, setContactPersonName] = useState('')
  const [email, setEmail] = useState('')
  const [phoneNumber, setPhoneNumber] = useState('998')
  const [isFieldDisable, setIsFieldDisable] = useState({
    hotelNameEN: false,
    hotelNameRU: false,
    hotelNameUZ: false,
    propertyType: false,
    contactPersonName: false,
  }) as any

  // category list state start
  const [subCategoryList, setSubCategoryList] = useState([])
  const [subCategorySelectedOptions, setSubCategorySelectedOptions] = useState<any>([])
  var subCategoryId = subCategorySelectedOptions
  // category list state end

  // hotel class list state start
  const hotelClassList = [
    {value: '0', label: `${t('No Star')}`},
    {value: '1', label: `1 ${t('Star')}`},
    {value: '2', label: `2 ${t('Star')}`},
    {value: '3', label: `3 ${t('Star')}`},
    {value: '4', label: `4 ${t('Star')}`},
    {value: '5', label: `5 ${t('Star')}`},
  ]
  const [hotelClassSelectedOptions, setHotelClassSelectedOptions] = useState<any>()
  // property type list state start
  const [propertyTypeList, setPropertyList] = useState([])
  const [propertyTypeSelectedOptions, setPropertyTypeSelectedOptions] = useState<any>('')

  // primary language list state start
  const [primaryLanguageList] = useState([
    {value: 'English', label: 'English'},
    {value: 'Russian', label: 'Русский'},
    {value: 'Uzbek', label: 'O’zbekcha'},
  ])
  const [primaryLanguageSelectedOptions, setPrimaryLanguageSelectedOptions] = useState<any>({
    value: 'English',
    label: 'English',
  })
  sessionStorage.setItem('primaryLanguage', primaryLanguageSelectedOptions.value)

  // primary language list state end
  const changePrimaryLanguage = (val: any) => {
    setPrimaryLanguageSelectedOptions(val)
    removeError('primaryLanguage')
    sessionStorage.setItem('primaryLanguage', val.value)
  }

  // set error state
  const [error, setError] = useState([
    {
      subCategoryId: '',
      hotelClass: '',
      hotelNameEN: '',
      hotelNameRU: '',
      hotelNameUZ: '',
      propertyType: '',
      contactPersonName: '',
      email: '',
      phoneNumber: '',
      primaryLanguage: '',
    },
  ])

  // remove validation function
  const removeError = (err: any) => {
    var tmp = [...error] as any
    tmp[0][err] = ''
    setError(tmp)
  }

  //   hotelSubcategory list api call
  const hotelSubcategoryAPIcall = async (categoryId: any) => {
    const param = {
      categoryId: categoryId,
    }
    var res = await fetchData('public/hotelSubcategory', param)

    if (res.status == '200') {
      var opt: any = []
      res.data.map((val: any) => {
        opt.push({value: val.subcategoryId, label: getTranslatedValue(lang, val, '_name')})
      })
      setSubCategoryList(opt)
    } else {
      toasterrormsg(res.message)
    }
  }
  const propertyTypeListAPIcall = async () => {
    var param = {
      categoryId: '1,2',
    }
    var res = await fetchData('public/propertytypeList', param)

    if (res.status == '200') {
      const groupedOptions: any = []

      // Define category labels
      const categoryLabels: {[key: string]: string} = {
        '1': t('Hotel & Resort'),
        '2': t('Pension & Stays'),
      }

      const categoryMap: {[key: string]: any} = {}

      res.data.forEach((val: any) => {
        const categoryId = val.categoryId.toString()
        if (!categoryMap[categoryId]) {
          categoryMap[categoryId] = {
            label: categoryLabels[categoryId] || 'Unknown Category',
            options: [],
          }
        }
        categoryMap[categoryId].options.push({
          value: val.propertytypeId,
          label: getTranslatedValue(lang, val, '_name'),
          categoryId: val.categoryId,
        })
      })

      // Convert grouped data into array format
      Object.values(categoryMap).forEach((group) => {
        groupedOptions.push(group)
      })

      setPropertyList(groupedOptions)
    } else {
      toasterrormsg(res.message)
    }
  }

  // validation function
  const validate = () => {
    var isValid = true
    var errorTmp = [...error]

    if (subCategorySelectedOptions.length == 0) {
      errorTmp[0].subCategoryId = t('Property Category Is Required')
      isValid = false
    }
    if (
      hotelClassSelectedOptions == undefined ||
      hotelClassSelectedOptions == null ||
      hotelClassSelectedOptions == ''
    ) {
      errorTmp[0].hotelClass = t('Property Class Is Required')
      isValid = false
    }
    if (
      propertyTypeSelectedOptions == undefined ||
      propertyTypeSelectedOptions == null ||
      propertyTypeSelectedOptions == ''
    ) {
      errorTmp[0].propertyType = t('Property Type Is Required')
      isValid = false
    }
    if (primaryLanguageSelectedOptions.value == 'English') {
      if (
        hotelNameEN.trim() == '' ||
        hotelNameEN.trim() == null ||
        hotelNameEN.trim() == undefined
      ) {
        errorTmp[0].hotelNameEN = t('Property Name Is Required')
        isValid = false
      } 
      // else if (!isSpecificSpecialCharacters(hotelNameEN.trim())) {
      //   errorTmp[0].hotelNameEN = t("Only <>,.'*() type Of Special Character Are Allow.")
      //   isValid = false
      // }
    } else if (primaryLanguageSelectedOptions.value == 'Russian') {
      if (
        hotelNameRU.trim() == '' ||
        hotelNameRU.trim() == null ||
        hotelNameRU.trim() == undefined
      ) {
        errorTmp[0].hotelNameRU = t('Property Name Is Required')
        isValid = false
      } 
      // else if (!hasSpecialCharacters(hotelNameRU.trim())) {
      //   errorTmp[0].hotelNameRU = t('Special Characters Is Not Allow')
      //   isValid = false
      // }
    } else if (primaryLanguageSelectedOptions.value == 'Uzbek') {
      if (
        hotelNameUZ.trim() == '' ||
        hotelNameUZ.trim() == null ||
        hotelNameUZ.trim() == undefined
      ) {
        errorTmp[0].hotelNameUZ = t('Property Name Is Required')
        isValid = false
      } 
      // else if (!hasSpecialCharacters(hotelNameUZ.trim())) {
      //   errorTmp[0].hotelNameUZ = t('Special Characters Is Not Allow')
      //   isValid = false
      // }
    }
    if (
      contactPersonName.trim() == '' ||
      contactPersonName.trim() == null ||
      contactPersonName.trim() == undefined
    ) {
      errorTmp[0].contactPersonName = t('Person Name Is Required')
      isValid = false
    } else if (!hasSpecialCharacters(contactPersonName.trim())) {
      errorTmp[0].contactPersonName = t('Special Characters Is Not Allow')
      isValid = false
    }
    if (email == '' || email == undefined || email == null) {
      errorTmp[0].email = t('Email Is Required')
      isValid = false
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}(?:\.[A-Z]{2,})?$/i.test(email)) {
      errorTmp[0].email = t('Please Enter Valid Email.')
      isValid = false
    }
    if (!phoneNumber) {
      errorTmp[0].phoneNumber = t('Mobile Number Is Required')
      isValid = false
    } else if (!/^\d+$/.test(phoneNumber)) {
      errorTmp[0].phoneNumber = t('Only Numbers Are Allowed.')
      isValid = false
    } else {
      // Remove non-numeric characters (like + or spaces)
      const numericPhone = phoneNumber.replace(/\D/g, '')
      // Validate phone number length
      if (numericPhone.length < 10 || numericPhone.length > 15) {
        errorTmp[0].phoneNumber = t('Please Enter Valid Mobile Number')
        isValid = false
      }
    }
    setError(errorTmp)
    return isValid
  }
  // add hotel api call
  const addHotelsApi = async () => {
    if (validate()) {
      setDisable(true)
      setLoading(true)
      let param: any = {
        vendorId: String(vendorId),
        en_name: hotelNameEN,
        ru_name: hotelNameRU,
        uz_name: hotelNameUZ,
        primaryLanguage: primaryLanguageSelectedOptions.value,
        subcategoryId: subCategoryId,
        hotelClass: hotelClassSelectedOptions.value,
        propertyType: String(propertyTypeSelectedOptions),
        contact_person_name: contactPersonName,
        email: email,
        mobileNumber: phoneNumber,
      }

      var res = await fetchData('public/addHotalV2', param)
      if (res.status == '200') {
        toastsuccessmsg(t('Basic Information Saved Successfully!'))
        var data = res.data[0]
        sessionStorage.setItem('primaryLanguage', data['primaryLanguage'])
        const state = {
          hotelId: data['hotelId'],
        }
        setTimeout(() => {
          if (data.isCriticalFieldChange) {
            navigate('../viewhotelcontract/', {state})
          } else {
            navigate('../addhotellocation/', {state})
          }
          setDisable(false)
        }, 1500)
      } else {
        toasterrormsg(res.message)
        setDisable(false)
      }
    }
  }

  // hotel Details api call
  const hotelDetailsApiCall = async () => {
    var param: any = {
      hotelId: editHotelId,
    }
    var response: any = await fetchData('public/hotelDetailsV2', param)

    if (response.status == '200') {
      setHotelDetails(response.data)
      var data = response.data[0]
      const isAllStepsCompleted = Object.values(data['completedSteps']).every((s) => s == true)
      if (isAllStepsCompleted && editHotelId !== '') {
        // Set all fields to true
        setIsFieldDisable((prev: any) => {
          const updatedFields = {} as any
          for (const key in prev) {
            updatedFields[key] = true
          }
          return updatedFields
        })
      }
      var subcategory: any = []
      data.subcategory.map((val: any) => {
        subcategory.push({value: val.subcategoryId, label: val.en_name})
      })
      setSubCategorySelectedOptions(subcategory[0] ? subcategory[0].value : [])

      let tmpObj = {
        label: data.hotelClass + ` ${t('Star')}`,
        value: data.hotelClass,
      }

      setHotelClassSelectedOptions(tmpObj)
      setHotelNameEN(data.en_name)
      setHotelNameRU(data.ru_name)
      setHotelNameUZ(data.uz_name)

      setPrimaryLanguageSelectedOptions({
        value: data.primaryLanguage,
        label: `${data.primaryLanguage}`,
      })

      if (data.propertyTypeDetail) {
        setPropertyTypeSelectedOptions(data.propertyTypeDetail[0].propertytypeId)
        const getCategoryId =
          propertyTypeList
            .flatMap((group: any) => group.options) // Flatten options array
            .find((option: any) => option.value == data.propertyTypeDetail[0].propertytypeId)
            ?.categoryId || ''
        hotelSubcategoryAPIcall(getCategoryId)
      }

      setContactPersonName(data.contact_person_name)
      setEmail(data.email)
      setPhoneNumber(data.mobileNumber)
    } else {
      toasterrormsg(response.message)
    }
  }

  // edit hotel api call
  const editHotelsApi = async () => {
    if (validate()) {
      setDisable(true)
      setLoading(true)
      let param: any = {
        hotelId: editHotelId,
        vendorId: String(vendorId),
        en_name: hotelNameEN,
        ru_name: hotelNameRU,
        uz_name: hotelNameUZ,
        primaryLanguage: primaryLanguageSelectedOptions.value,
        subcategoryId: subCategoryId,
        hotelClass: hotelClassSelectedOptions.value,
        propertyType: String(propertyTypeSelectedOptions),
        contact_person_name: contactPersonName,
        email: email,
        mobileNumber: phoneNumber,
      }

      var res = await fetchData('public/addHotalV2', param)
      if (res.status == '200') {
        toastsuccessmsg(t('Basic Information Saved Successfully!'))
        var data = res.data[0]
        sessionStorage.setItem('primaryLanguage', data['primaryLanguage'])
        const state = {
          hotelId: data['hotelId'],
        }
        setTimeout(() => {
          if (data.isCriticalFieldChange) {
            navigate('../viewhotelcontract/', {state})
          } else {
            navigate('../addhotellocation/', {state})
          }
          setDisable(false)
          setLoading(false)
        }, 1500)
      } else {
        toasterrormsg(res.message)
        setDisable(false)
        setLoading(false)
      }
    }
  }

  useEffect(() => {
    if (editHotelId != '') {
      hotelDetailsApiCall()
    }
    propertyTypeListAPIcall()
  }, [])

  const criticalFieldChange = (field: string) => {
    Swal.fire({
      title: t(
        'Please note that modifying this detail will require the preparation and signing of a new contract to ensure all parties are in agreement with the revised terms!'
      ),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: t('Ok'),
      cancelButtonText: t('Cancel'),
    }).then(async (result) => {
      if (result.isConfirmed) {
        setIsFieldDisable((prev: any) => ({
          ...prev,
          [field]: false,
        }))
      }
    })
  }
  return (
    <>
      <ToastContainer />
      <PageTitle breadcrumbs={[]}>
        {editHotelId != '' ? t('Edit Basic Information') : t('Add Basic Information')}
      </PageTitle>
      <AddHotelHeader hotelId={editHotelId} />
      <div className='d-flex flex-column flex-column-fluid'>
        {/* <!--begin::Content--> */}
        <div id='kt_app_content' className='app-content flex-column-fluid'>
          {/* <!--begin::Form--> */}
          <div className='form d-flex flex-column flex-lg-row'>
            {/* <!--begin::Main column--> */}
            <div className='d-flex flex-column flex-row-fluid gap-7 gap-lg-10'>
              {/* <!--begin::Tab content--> */}
              <div className='tab-content'>
                {/* <!--begin::Tab pane--> */}
                <div
                  className='tab-pane fade show active'
                  id='kt_ecommerce_add_product_general'
                  role='tab-panel'
                >
                  <div className='d-flex flex-column'>
                    {/* <!--begin::General options--> */}
                    <div className='card card-flush py-4'>
                      {/* <!--begin::Card header--> */}
                      <div className='card-header d-flex'>
                        {/* <!--begin::Card title--> */}
                        <div className='card-title'>
                          <h2>{t('Property Basic Information')}</h2>
                        </div>
                        {/* <!--end::Card title--> */}
                        <div className='d-flex align-items-center w-200px w-sm-300px flex-column'>
                          {hotelDetails?.length != 0 ? (
                            <>
                              {hotelDetails?.map((completedSteps: any, index: any) => {
                                var percentage = 0
                                if (completedSteps['completedSteps']['basicInfo']) {
                                  percentage = 10
                                }
                                if (completedSteps['completedSteps']['location']) {
                                  percentage = 20
                                }
                                if (completedSteps['completedSteps']['propertyDetail']) {
                                  percentage = 40
                                }
                                if (completedSteps['completedSteps']['roomAndSpace']) {
                                  percentage = 50
                                }
                                if (completedSteps['completedSteps']['photos']) {
                                  percentage = 60
                                }
                                if (completedSteps['completedSteps']['facilitiesAndServices']) {
                                  percentage = 70
                                }
                                if (completedSteps['completedSteps']['policies']) {
                                  percentage = 90
                                }
                                if (completedSteps['completedSteps']['financeAndLegal']) {
                                  percentage = 100
                                }
                                return (
                                  <React.Fragment key={index}>
                                    <div className='d-flex justify-content-between w-100 mt-auto'>
                                      <span className='fw-bold fs-6'>{t('Completion')}</span>
                                      <span className='fw-bolder fs-6'>{percentage}%</span>
                                    </div>
                                    <div className='h-5px mx-3 w-100 bg-light mb-3'>
                                      <div
                                        className='bg-success rounded h-5px'
                                        role='progressbar'
                                        style={{width: `${percentage}%`}}
                                      ></div>
                                    </div>
                                  </React.Fragment>
                                )
                              })}
                            </>
                          ) : (
                            <>
                              <div className='d-flex justify-content-between w-100 mt-auto'>
                                <span className='fw-bold fs-6'>{'Completion'}</span>
                                <span className='fw-bolder fs-6'>0%</span>
                              </div>
                              <div className='h-5px mx-3 w-100 bg-light mb-3'>
                                <div
                                  className='bg-success rounded h-5px'
                                  role='progressbar'
                                  style={{width: '0%'}}
                                ></div>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                      {/* <!--end::Card header--> */}
                      {/* <!--begin::Card body--> */}
                      <div className='card-body pt-10'>
                        {/* <!--begin::Input group--> */}
                        <div className='row'>
                          <div className='col-lg-4 my-3'>
                            {/* <!--begin::Label--> */}
                            <label className='fs-4 form-label required'>
                              {t('Primary Language')}
                            </label>
                            {/* <!--end::Label--> */}
                            {/* <!--begin::Input--> */}
                            <Select
                              name='primaryLanguage[]'
                              id='primaryLanguage'
                              placeholder={t('Select Primary Language')}
                              isSearchable={true}
                              options={primaryLanguageList}
                              value={primaryLanguageSelectedOptions}
                              onChange={(e: any) => {
                                changePrimaryLanguage(e)
                              }}
                            />
                            {/* <!--end::Input--> */}
                            <div className='text-danger fw-bold'>{error[0].primaryLanguage}</div>
                          </div>
                        </div>
                        {/* <!--end::Input group--> */}
                      </div>
                      {/* <!--begin::Card body--> */}
                      <div className='card-body pt-0'>
                        {primaryLanguageSelectedOptions.value == 'English' && (
                          <>
                            {/* <!--begin::Input group--> */}
                            <div className='row'>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='required fs-4 form-label'>
                                  {t('Property Name (English)')}
                                </label>
                                <button
                                  type='button'
                                  className='btn btn-sm bg-light-primary bg-hover-success text-hover-white p-1 ms-3'
                                  onClick={() => criticalFieldChange('hotelNameEN')}
                                >
                                  <KTIcon iconName='notepad-edit' className='ps-1 pb-1'></KTIcon>
                                </button>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <input
                                  type='text'
                                  name='hotelNameEN'
                                  disabled={isFieldDisable.hotelNameEN}
                                  className='form-control mb-2'
                                  placeholder={t('Property Name')}
                                  value={hotelNameEN}
                                  onChange={(e) => {
                                    setHotelNameEN(e.target.value)
                                    removeError('hotelNameEN')
                                  }}
                                />
                                {/* <!--end::Input--> */}
                                <div className='text-danger fw-bold'>{error[0].hotelNameEN}</div>
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 form-label'>
                                  {t('Property Name (Russian)')}
                                </label>
                                <button
                                  type='button'
                                  className='btn btn-sm bg-light-primary bg-hover-success text-hover-white p-1 ms-3'
                                  onClick={() => criticalFieldChange('hotelNameRU')}
                                >
                                  <KTIcon iconName='notepad-edit' className='ps-1 pb-1'></KTIcon>
                                </button>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <input
                                  type='text'
                                  name='hotelNameRU'
                                  disabled={isFieldDisable.hotelNameRU}
                                  className='form-control mb-2'
                                  placeholder={t('Property Name')}
                                  value={hotelNameRU}
                                  onChange={(e) => {
                                    setHotelNameRU(e.target.value)
                                  }}
                                />
                                {/* <!--end::Input--> */}
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 form-label'>
                                  {t('Property Name (Uzbek)')}
                                </label>
                                <button
                                  type='button'
                                  className='btn btn-sm bg-light-primary bg-hover-success text-hover-white p-1 ms-3'
                                  onClick={() => criticalFieldChange('hotelNameUZ')}
                                >
                                  <KTIcon iconName='notepad-edit' className='ps-1 pb-1'></KTIcon>
                                </button>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <input
                                  type='text'
                                  name='hotelNameUZ'
                                  disabled={isFieldDisable.hotelNameUZ}
                                  className='form-control mb-2'
                                  placeholder={t('Property Name')}
                                  value={hotelNameUZ}
                                  onChange={(e) => {
                                    setHotelNameUZ(e.target.value)
                                  }}
                                />
                                {/* <!--end::Input--> */}
                              </div>
                            </div>
                            {/* <!--end::Input group--> */}
                          </>
                        )}
                        {primaryLanguageSelectedOptions.value == 'Russian' && (
                          <>
                            {/* <!--begin::Input group--> */}
                            <div className='row'>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='required fs-4 form-label'>
                                  {t('Property Name (Russian)')}
                                </label>
                                <button
                                  type='button'
                                  className='btn btn-sm bg-light-primary bg-hover-success text-hover-white p-1 ms-3'
                                  onClick={() => criticalFieldChange('hotelNameRU')}
                                >
                                  <KTIcon iconName='notepad-edit' className='ps-1 pb-1'></KTIcon>
                                </button>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <input
                                  type='text'
                                  name='hotelNameRU'
                                  disabled={isFieldDisable.hotelNameRU}
                                  className='form-control mb-2'
                                  placeholder={t('Property Name')}
                                  value={hotelNameRU}
                                  onChange={(e) => {
                                    setHotelNameRU(e.target.value)
                                  }}
                                />
                                <div className='text-danger fw-bold'>{error[0].hotelNameRU}</div>
                                {/* <!--end::Input--> */}
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 form-label'>
                                  {t('Property Name (English)')}
                                </label>
                                <button
                                  type='button'
                                  className='btn btn-sm bg-light-primary bg-hover-success text-hover-white p-1 ms-3'
                                  onClick={() => criticalFieldChange('hotelNameEN')}
                                >
                                  <KTIcon iconName='notepad-edit' className='ps-1 pb-1'></KTIcon>
                                </button>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <input
                                  type='text'
                                  name='hotelNameEN'
                                  disabled={isFieldDisable.hotelNameEN}
                                  className='form-control mb-2'
                                  placeholder={t('Property Name')}
                                  value={hotelNameEN}
                                  onChange={(e) => {
                                    setHotelNameEN(e.target.value)
                                    removeError('hotelNameEN')
                                  }}
                                />
                                {/* <!--end::Input--> */}
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 form-label'>
                                  {t('Property Name (Uzbek)')}
                                </label>
                                <button
                                  type='button'
                                  className='btn btn-sm bg-light-primary bg-hover-success text-hover-white p-1 ms-3'
                                  onClick={() => criticalFieldChange('hotelNameUZ')}
                                >
                                  <KTIcon iconName='notepad-edit' className='ps-1 pb-1'></KTIcon>
                                </button>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <input
                                  type='text'
                                  name='hotelNameUZ'
                                  disabled={isFieldDisable.hotelNameUZ}
                                  className='form-control mb-2'
                                  placeholder={t('Property Name')}
                                  value={hotelNameUZ}
                                  onChange={(e) => {
                                    setHotelNameUZ(e.target.value)
                                  }}
                                />
                                {/* <!--end::Input--> */}
                              </div>
                            </div>
                            {/* <!--end::Input group--> */}
                          </>
                        )}
                        {primaryLanguageSelectedOptions.value == 'Uzbek' && (
                          <>
                            {/* <!--begin::Input group--> */}
                            <div className='row'>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='required fs-4 form-label'>
                                  {t('Property Name (Uzbek)')}
                                </label>
                                <button
                                  type='button'
                                  className='btn btn-sm bg-light-primary bg-hover-success text-hover-white p-1 ms-3'
                                  onClick={() => criticalFieldChange('hotelNameUZ')}
                                >
                                  <KTIcon iconName='notepad-edit' className='ps-1 pb-1'></KTIcon>
                                </button>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <input
                                  type='text'
                                  name='hotelNameUZ'
                                  disabled={isFieldDisable.hotelNameUZ}
                                  className='form-control mb-2'
                                  placeholder={t('Property Name')}
                                  value={hotelNameUZ}
                                  onChange={(e) => {
                                    setHotelNameUZ(e.target.value)
                                  }}
                                />
                                {/* <!--end::Input--> */}
                                <div className='text-danger fw-bold'>{error[0].hotelNameUZ}</div>
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 form-label'>
                                  {t('Property Name (Russian)')}
                                </label>
                                <button
                                  type='button'
                                  className='btn btn-sm bg-light-primary bg-hover-success text-hover-white p-1 ms-3'
                                  onClick={() => criticalFieldChange('hotelNameRU')}
                                >
                                  <KTIcon iconName='notepad-edit' className='ps-1 pb-1'></KTIcon>
                                </button>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <input
                                  type='text'
                                  name='hotelNameRU'
                                  disabled={isFieldDisable.hotelNameRU}
                                  className='form-control mb-2'
                                  placeholder={t('Property Name')}
                                  value={hotelNameRU}
                                  onChange={(e) => {
                                    setHotelNameRU(e.target.value)
                                  }}
                                />
                                {/* <!--end::Input--> */}
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 form-label'>
                                  {t('Property Name (English)')}
                                </label>
                                <button
                                  type='button'
                                  className='btn btn-sm bg-light-primary bg-hover-success text-hover-white p-1 ms-3'
                                  onClick={() => criticalFieldChange('hotelNameEN')}
                                >
                                  <KTIcon iconName='notepad-edit' className='ps-1 pb-1'></KTIcon>
                                </button>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <input
                                  type='text'
                                  name='hotelNameEN'
                                  disabled={isFieldDisable.hotelNameEN}
                                  className='form-control mb-2'
                                  placeholder={t('Property Name')}
                                  value={hotelNameEN}
                                  onChange={(e) => {
                                    setHotelNameEN(e.target.value)
                                    removeError('hotelNameEN')
                                  }}
                                />
                                {/* <!--end::Input--> */}
                              </div>
                            </div>
                            {/* <!--end::Input group--> */}
                          </>
                        )}
                      </div>
                      {/* <!--begin::Card body--> */}
                      <div className='card-body pt-0'>
                        {/* <!--begin::Input group--> */}
                        <div className='row'>
                          <div className='col-lg-4 my-3'>
                            <label className='fs-4 required form-label'>{t('Property Type')}</label>
                            <button
                              type='button'
                              className='btn btn-sm bg-light-primary bg-hover-success text-hover-white p-1 ms-3'
                              onClick={() => criticalFieldChange('propertyType')}
                            >
                              <KTIcon iconName='notepad-edit' className='ps-1 pb-1'></KTIcon>
                            </button>
                            <Select
                              name='propertyType'
                              id='propertyType'
                              placeholder={t('Select')}
                              isSearchable={true}
                              options={propertyTypeList}
                              isDisabled={isFieldDisable.propertyType}
                              value={
                                propertyTypeList
                                  .flatMap((group: any) => group.options) // Flatten options array
                                  .find(
                                    (option: any) => option.value == propertyTypeSelectedOptions
                                  ) || null
                              }
                              onChange={(e: any) => {
                                setPropertyTypeSelectedOptions(e.value)
                                hotelSubcategoryAPIcall(e.categoryId)
                                removeError('propertyType')
                              }}
                            />
                            <div className='text-danger fw-bold'>{error[0].propertyType}</div>
                          </div>
                          <div className='col-lg-4 my-3'>
                            <label className='required fs-4 form-label'>
                              {t('Property Category')}
                            </label>
                            <Select
                              name='subCategory[]'
                              id='subCategoryListId'
                              placeholder={t('Select Category')}
                              isSearchable={true}
                              options={subCategoryList}
                              value={
                                subCategoryList.find(
                                  (option: any) => option.value == subCategorySelectedOptions
                                ) || null
                              }
                              onChange={(e: any) => {
                                setSubCategorySelectedOptions(e.value)
                                removeError('subCategoryId')
                              }}
                            />
                            <div className='text-danger fw-bold'>{error[0].subCategoryId}</div>
                          </div>
                        </div>
                        {/* <!--end::Input group--> */}
                      </div>
                      <div className='card-body pt-0'>
                        <div className='row'>
                          <div className='col-lg-4 my-3'>
                            {/* <!--begin::Label--> */}
                            <label className='required fs-4 form-label'>
                              {t('Property Class')}
                            </label>
                            {/* <!--end::Label--> */}
                            {/* <!--begin::Input--> */}
                            <Select
                              name='hotelClass[]'
                              id='hotelClassList'
                              placeholder={t('Select Property Class')}
                              isSearchable={true}
                              options={hotelClassList}
                              value={hotelClassSelectedOptions}
                              onChange={(e: any) => {
                                setHotelClassSelectedOptions(e)
                                removeError('hotelClass')
                              }}
                            />
                            {/* <!--end::Input--> */}
                            <div className='text-danger fw-bold'>{error[0].hotelClass}</div>
                          </div>
                        </div>
                      </div>
                      {/* end::Form group */}
                      {/* <!--begin::Card body--> */}
                      <div className='card-body pt-0'>
                        {/* <!--begin::Input group--> */}
                        <div className='row'>
                          <div className='col-lg-4 my-3'>
                            {/* <!--begin::Label--> */}
                            <label className='required fs-4 form-label'>
                              {t('Contact Person Name')}
                            </label>
                            <button
                              type='button'
                              className='btn btn-sm bg-light-primary bg-hover-success text-hover-white p-1 ms-3'
                              onClick={() => criticalFieldChange('contactPersonName')}
                            >
                              <KTIcon iconName='notepad-edit' className='ps-1 pb-1'></KTIcon>
                            </button>
                            {/* <!--end::Label--> */}
                            {/* <!--begin::Input--> */}
                            <input
                              type='text'
                              name='contactPersonName'
                              disabled={isFieldDisable.contactPersonName}
                              className='form-control mb-2'
                              placeholder={t('Contact Person Name')}
                              value={contactPersonName}
                              onChange={(e) => {
                                setContactPersonName(e.target.value)
                                removeError('contactPersonName')
                              }}
                            />
                            {/* <!--end::Input--> */}
                            <div className='text-danger fw-bold'>{error[0].contactPersonName}</div>
                          </div>
                          <div className='col-lg-4 my-3'>
                            {/* <!--begin::Label--> */}
                            <label className='fs-4 form-label required'>{t('Email')}</label>
                            {/* <!--end::Label--> */}
                            {/* <!--begin::Input--> */}
                            <input
                              type='text'
                              name='email'
                              className='form-control mb-2'
                              placeholder={t('Email')}
                              value={email}
                              onChange={(e) => {
                                setEmail(e.target.value)
                                removeError('email')
                              }}
                            />
                            {/* <!--end::Input--> */}
                            <div className='text-danger fw-bold'>{error[0].email}</div>
                          </div>
                          <div className='col-lg-4 my-3'>
                            {/* <!--begin::Label--> */}
                            <label className='fs-4 form-label required'>{t('Phone Number')}</label>
                            {/* <!--end::Label--> */}
                            {/* <!--begin::Input--> */}
                            <PhoneInput
                              inputClass='form-control form-control-lg form-control-solid w-100'
                              placeholder={t('Phone Number')}
                              enableSearch={true}
                              value={phoneNumber}
                              onChange={(e) => {
                                setPhoneNumber(e)
                                removeError('phoneNumber')
                              }}
                            />
                            {/* <!--end::Input--> */}
                            <div className='text-danger fw-bold'>{error[0].phoneNumber}</div>
                          </div>
                        </div>
                        {/* <!--end::Input group--> */}
                      </div>
                      {/* <!--begin::Card body--> */}
                    </div>
                    {/* <!--end::Pricing--> */}
                  </div>
                </div>
                {/* <!--end::Tab pane--> */}
              </div>
              {/* <!--end::Tab content--> */}
              <div className='d-flex justify-content-end'>
                {/* <!--begin::Button--> */}
                <Link
                  to='../viewhotels/'
                  id='kt_ecommerce_add_product_cancel'
                  className='btn btn-light me-5'
                >
                  {t('Cancel')}
                </Link>
                {/* <!--end::Button--> */}
                <button
                  type='button'
                  disabled={disable}
                  className='btn btn-primary'
                  onClick={() => {
                    if (editHotelId !== '') {
                      editHotelsApi()
                    } else {
                      addHotelsApi()
                    }
                  }}
                >
                  <span className='indicator-label'>{t('Next')}</span>
                  {loading && (
                    <span
                      className='spinner-border spinner-border-sm mx-2'
                      role='status'
                      aria-hidden='true'
                    ></span>
                  )}
                </button>
                {/* <!--end::Button--> */}
              </div>
            </div>
            {/* <!--end::Main column--> */}
          </div>
          {/* <!--end::Form--> */}
        </div>
        {/* <!--end::Content--> */}
      </div>
    </>
  )
}

export {AddHotelBasicInfo}
